import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import Button from "Shared/Button";
import { useNote, useUpdateNote } from "../../hooks/useItemInteractions";
import styles from "./ItemNote.module.css";

export function ItemNote({ stockId, isEditing, onClose }) {
  const { data: noteData } = useNote(stockId);
  const updateNote = useUpdateNote();
  const [noteText, setNoteText] = useState("");

  useEffect(() => {
    if (noteData?.text != null) setNoteText(noteData.text);
  }, [noteData?.text]);

  if (!isEditing) {
    if (!noteData?.text) return null;
    return (
      <div className={styles.noteBlock}>
        <p className={styles.noteHint}>
          <FontAwesomeIcon icon={faPencil} className={styles.noteIcon} />
          {noteData.text}
        </p>
      </div>
    );
  }

  return (
    <div className={styles.noteBlock} onClick={(e) => e.stopPropagation()}>
      <textarea
        className={styles.noteTextarea}
        value={noteText}
        placeholder="This is a personal note that only you can see"
        onChange={(e) => setNoteText(e.target.value)}
        rows={3}
      />
      <div className={styles.noteActions}>
        {noteData?.text ? (
          <Button
            text="Delete"
            className="deleteBtn"
            onClick={() => {
              updateNote.mutate({ stockId, text: "" });
              setNoteText("");
              onClose?.();
            }}
          />
        ) : (
          <span />
        )}
        <div className={styles.noteActionsRight}>
          <Button
            text="Cancel"
            className="cancelBtn"
            onClick={() => {
              setNoteText(noteData?.text ?? "");
              onClose?.();
            }}
          />
          <Button
            text="Save"
            className="saveBtn"
            onClick={() => {
              updateNote.mutate({ stockId, text: noteText });
              onClose?.();
            }}
          />
        </div>
      </div>
    </div>
  );
}

ItemNote.propTypes = {
  stockId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isEditing: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ItemNote;
